import React, { useState, useEffect } from 'react'
import { NeverBounce } from 'newComponents'
import { getUtmValuesFromCookie } from '../../../utils/thirdPartyUtils'
import './styles.scss'

const personalDemoThreshold = 20

function fillUtmParams() {
  const utmValues = getUtmValuesFromCookie()
  const marketoForm = window.MktoForms2.allForms()[0]
  marketoForm.addHiddenFields({
    ftutmsource: `${utmValues.__ft_utm_source}`,
    ftutmmedium: `${utmValues.__ft_utm_medium}`,
    ftutmcampaign: `${utmValues.__ft_utm_campaign}`,
    ftutmterm: `${utmValues.__ft_utm_term}`,
    ftutmcontent: `${utmValues.__ft_utm_content}`,
    ltutmsource: `${utmValues.__lt_utm_source}`,
    ltutmmedium: `${utmValues.__lt_utm_medium}`,
    ltutmcampaign: `${utmValues.__lt_utm_campaign}`,
    ltutmterm: `${utmValues.__lt_utm_term}`,
    ltutmcontent: `${utmValues.__lt_utm_content}`
  })
}

function NeverBounceScript() {
  const script = document.createElement('script')
  script.src = 'https://cdn.neverbounce.com/widget/dist/NeverBounce.js'
  script.async = true

  window._NBSettings = {
    apiKey: 'public_e7f6bed129044da005b8c16326040993',
    blockFreemail: false,
    blockRoleAccount: true,
    blockThrottledAttempts: true,
    displayPoweredBy: false,
    feedback: true,
    feedbackClass: 'nb-feedback',
    inputLatency: 999,
    rejectedMessage: 'invalid email',
    softRejectMessage: 'enter an email',
    freemailRejectMessage: 'enter a business email',
    throttleRejectMessage: 'too many attempts, try again later',
    timeout: 60
  }
  document.querySelector('body').appendChild(script)
}

function appendScript(baseUrl, setScriptLoaded) {
  if (window.MktoForms2) return setScriptLoaded(true)

  const script = document.createElement('script')
  script.src = `${baseUrl}/js/forms2/js/forms2.min.js`
  script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null)
  document.body.appendChild(script)
}

function useMarketo({ baseUrl, munchkinId, formId, newForm }) {
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [formLoaded, setFormLoaded] = useState(false)

  useEffect(() => {
    if (scriptLoaded && !formLoaded ) {
      window.MktoForms2.loadForm(baseUrl, munchkinId, formId, (form) => {
        NeverBounceScript()
        form.onSuccess((values, followUpUrl) => {
          setFormLoaded(true)
          postSubmitRedirectUsingClearbit(form, followUpUrl, newForm)
          return false
        })
      })
      window.MktoForms2.onFormRender((form) => {
        if (newForm) {
          updatePlaceHolder(form.getFormElem())
        }
      })
    }
    if (formLoaded) {
      fillUtmParams()
    }
    appendScript(baseUrl, setScriptLoaded)
  }, [scriptLoaded, baseUrl, munchkinId, formId, formLoaded])
}

const updatePlaceHolder = (form) => {
  const inputs = form.find('input')
  const textareas = form.find('textarea')

  inputs.each((i) => {
    const input = inputs[i]
    const label = input.parentNode.getElementsByTagName('label')
    if (label.length > 0) {
      input.setAttribute('placeholder', label[0].textContent)
    }
  })

  textareas.each((i) => {
    const textarea = textareas[i]
    const label = textarea.parentNode.getElementsByTagName('label')
    if (label.length > 0) {
      textarea.setAttribute('placeholder', label[0].textContent)
    }
  })
}

function loadClearbit() {
  const pollForDefinition = function (scope, varname, callback) {
    if (typeof scope[varname] !== 'undefined') {
      return callback()
    }
    const interval = setInterval(function () {
      if (typeof scope[varname] !== 'undefined') {
        clearInterval(interval)
        callback()
      }
    }, 250)
  }

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://marketo.clearbit.com/assets/v1/marketo/forms.js'
    script.async = true
    script.setAttribute('data-clearbit-publishable-key', 'pk_b49bff58911072e9fc652774c9c55b7a')
    script.onerror = function (e) {
      console.log('Clearbit Form JS unable to load')
      pollForDefinition(window, 'MktoForms2', function () {
        MktoForms2.whenReady(function (form) {
          form.setValues({ clearbitFormStatus: 'Clearbit Form JS unable to load' })
        })
      })
    }
    document.querySelector('head').appendChild(script)
  },[])
}

function postSubmitRedirectUsingClearbit(form, followUpUrl, newForm) {
  if (newForm) {
    if(parseInt(document.querySelector('input[name="NumberOfEmployees"]').value) > personalDemoThreshold) {
      // Redirect to Thank you Personal Demo page
      document.location = '/thank-you-pd'
    } else {
      // Redirect to Thank you Recorded Demo page
      document.location = '/thank-you-rd'
    }
  } else {
    document.location = followUpUrl
  }
}

const MarketoForm = ({ formId, newForm }) => {
  const baseUrl = '//app-sj31.marketo.com'
  const munchkinId = '850-KKH-319'

  useMarketo({ baseUrl, munchkinId, formId, newForm })
  if (newForm) {
    loadClearbit()
  }

  return (
    <div className="mkto-form-shell">
      <form id={`mktoForm_${formId}`} />
      <style>
        {/* Form styling */}
        {`.mobile-only .form-page-form-side {background: #0e1932;} .mktoForm-wrapper .mktoForm {width: 100% !important; max-width: 500px !important; } .mktoLabel {display: none;} .mktoForm-wrapper {display: block;}.mktoForm-wrapper .mktoForm {display: block; margin: auto;}.mktoForm-wrapper .mktoForm .mktoGutter, .mktoForm-wrapper .mktoForm .mktoOffset {display: none;}.mktoForm-wrapper .mktoForm .mktoFieldWrap {margin-bottom: 20px;}@media all and (min-width: 769px) {.mktoForm-wrapper .mktoForm .mktoFieldWrap {margin-bottom: 10px;}}.mktoForm-wrapper .mktoForm .mktoFieldWrap input {border: solid 1px #A5A9B1 !important;outline: none;width: 100% !important;height: auto;}.mktoForm-wrapper .mktoForm .mktoFieldWrap input:focus, .mktoForm-wrapper .mktoForm .mktoFieldWrap input:active {border-color: #14B6A0 !important;}.mktoForm-wrapper .mktoForm .mktoFieldWrap input::placeholder {color: #A5A9B1;}.mktoForm-wrapper .mktoForm .mktoFieldWrap input {padding: 16px 10px;border-radius: 6px;}.mktoForm-wrapper .mktoForm .mktoFieldWrap textarea {border-radius: 8px;padding: 10px;}.mktoForm-wrapper .mktoForm .mktoFieldWrap #Description__c {margin-top: 0 !important;}.mktoForm-wrapper .mktoForm .mktoButtonRow {margin: 10px 0 30px !important;}@media all and (max-width: 1260px) {.mktoForm-wrapper .mktoForm .mktoButtonRow {width: 100%;text-align: center;}}.mktoForm-wrapper .mktoForm .mktoButtonRow .mktoButtonWrap {margin: 0 !important;}.mktoForm-wrapper .mktoForm .mktoButtonRow .mktoButtonWrap .mktoButton {border-radius: 40px !important;border: none !important;transition: all 0.3s ease;background: #0ca691;color: #fff;position: relative;box-shadow: none; font-weight: 700; padding: .9375rem 2.5rem; border-radius: 4.125rem; font-size: 16px; font-family: Nunito Sans,sans-serif; }.mktoForm-wrapper .mktoForm .mktoButtonRow .mktoButtonWrap .mktoButton:before {display: none;}.mktoForm-wrapper .mktoForm .mktoButtonRow .mktoButtonWrap .mktoButton:after {content: ' ';display: inline-block;margin-left: 10px;position: relative;width: 12px;height: 12px;top: 1px;transition: all 0.3s ease; background: url(/img/support/arrow-right-white.svg); transition: all 0.3s ease; right: 0;}.mktoForm-wrapper .mktoForm .mktoButtonRow .mktoButtonWrap .mktoButton:hover {transform: translateY(-1px);}.mktoForm-wrapper .mktoForm .mktoButtonRow .mktoButtonWrap .mktoButton:hover:after {right: -3px;} .mktoForm-wrapper .mktoForm .mktoFieldWrap textarea { width: 100% !important; height: 75px; outline: none; border: solid #A5A9B1 1px; border-radius: 6px;} .mktoForm-wrapper .mktoForm .mktoFieldWrap textarea::placeholder { color: #A5A9B1 !important; } .mktoForm-wrapper .mktoForm .mktoFieldWrap textarea:focus, .mktoForm-wrapper .mktoForm .mktoFieldWrap textarea:active { border-color:#14B6A0 !important; }  `}
        {/* Neverbounce styling */}
        {`.mktoForm .mktoFormRow .mktoFieldWrap div.nb-feedback{display:block !important;top:-5px !important;left:auto !important;width:auto !important;float:left !important;height:40px !important;position:relative !important}@media all and (min-width:800px) and (max-width:1259px){.mktoForm .mktoFormRow .mktoFieldWrap div.nb-feedback{height:40px !important;position:absolute !important;top:45px !important;display:block !important;top:-5px !important;left:auto !important;width:auto !important;float:right !important;left:102% !important}}@media all and (min-width:1400px){.mktoForm .mktoFormRow .mktoFieldWrap div.nb-feedback{height:40px !important;position:absolute !important;top:45px !important;display:block !important;top:-5px !important;left:auto !important;width:auto !important;float:right !important;left:102% !important}} .mktoFieldWrap div[id^=nb-field-] div.nb-feedback .nb-result{display:flex !important;white-space:nowrap !important}`}
      </style>
    </div>
  )
}

export default MarketoForm
